<template>
  <div class="header" style="text-align: center">
    <headTop :data="'yes'" :imgShow="false"></headTop>
    <img src="../../assets/images/智慧党建AI助手 (1).png" style="margin: 100px auto">
  <div class="wid-1200" style="width: 1270px">
    <!--面包屑-->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>智能问答</el-breadcrumb-item>
    </el-breadcrumb>-->
    <div class="main">
      <div class="main-l">
        <div style="text-align: left;margin: 10px 0" v-if="resShow">
<!--          <img src="../../assets/images/Fram51.png" style="">-->
        </div>
        <el-scrollbar style="height:600px" v-if="resShow">
        <ul class="qa-list">
          <li :id="`item${i}`" v-for="(item, i) in list" :key="i">
            <span class="question" v-if="i % 2 == 0">{{ item }}</span>
            <template v-else>
              <!-- 推荐问题列表 -->
              <div class="question-list" v-if="item.isQuestionList">
                <template v-if="item.isQKList">没找到此期刊，为您推荐以下期刊：</template>
                <template v-else-if="item.isYZList">没找到此原著，为您推荐以下原著：</template>
                <template v-else>为您找到以下问题，请选择：</template>
                <ul>
                  <li v-for="item in item.answer" :key="item.uid" @click="questionListClick(item)">{{ item.question || item.value || item.buildTitle || item.name }}</li>
                </ul>
                <span v-if="item.isMore" class="is-more" @click="showMore(i)">更多</span>
              </div>
              <!-- 期刊和原著显示 -->
              <div class="qk-answer" v-else-if="item.isQKOrYZ">
                <div class="bg-w" style="text-align: left">
                  <a :href="item.answer.url || item.answer.linkUrl" target="_blank" style="width: 100%;">
                  <img :src="item.answer.smallImageLink || item.answer.imageUrl" alt="">
                    <div style="display: inline-block;width: calc(100% - 120px);    line-height: 26px;vertical-align: middle;">
                      <div style="margin-left: 20px">{{ item.answer.name || item.answer.buildTitle }}</div>
                      <div style="margin-left: 20px">{{ item.answer.orgUnit || item.answer.author }}</div>
                    </div>
                  </a>
                </div>

              </div>
              <!-- AI助手显示 -->
              <div class="qk-answer" v-else-if="item.isAI">
                <div class="bg-w">
                  <div v-html="item.result.data[0].content" class="text-div close-text" style="text-align: left;  text-indent: 2em; ">
                  </div>
                  <button class="btn" @click="openText($event)" v-show="textOpen" style="    width: 46px;    height: 25px;    border-radius: 5px;    cursor: pointer;margin-top: 10px">展开</button>
                  <button class="btn" @click="closeText($event)" v-show="!textOpen"  style="    width: 46px;    height: 25px;    border-radius: 5px;    cursor: pointer;margin-top: 10px">收起</button>

                  <!--                  {{item.result.data[0].content.replace('/r','<br/>')}}-->
                  <div style="text-align: left;margin-top: 10px">

<!--                    <img src="../../assets/images/tipsss.png" style="width: 220px;height: 13px;margin: 10px 0 ">-->
                  </div>
                  <div>
                    <markMap  :content="item.result.mk" :idName="'mk'+i"></markMap>
                    <el-table
                        border
                        stripe
                        :data="item.result.data"
                        style="width: 100%">
                      <el-table-column
                          label="相关内容"
                          width="550">
                        <template slot-scope="scope">
<!--                          <div v-html="scope.row.content">-->
<!--                          </div>-->
                            <el-popover width="540" popper-class="pop-span" trigger="hover" placement="top">
                              <p  v-html="scope.row.content" style="max-height: 300px;overflow: auto"></p>
                              <div slot="reference" class="name-wrapper">
                                <p class="close-text" v-html="scope.row.content" style="width: 100%"></p>
                              </div>
                            </el-popover>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="来源"
                      >
                        <template slot-scope="scope">
<!--                          <a v-html="scope.row.source" :href="scope.row.link" target="_blank" style="color: #D72D2D">
                          </a>-->
                          <span v-if="scope.row.link==''" v-html="scope.row.source"></span>
                          <a v-else :href="scope.row.link" target="_blank" style="color: #D72D2D" v-html="scope.row.source"></a>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
<!--                {{ JSON.stringify(item) }}-->

<!--                <a :href="item.answer.url || item.answer.linkUrl" target="_blank"><img :src="item.answer.smallImageLink || item.answer.imageUrl" alt=""></a>
                <span>{{ item.answer.name || item.answer.buildTitle }}</span>
                <span>{{ item.answer.orgUnit || item.answer.author }}</span>-->
              </div>
              <!-- 有明确的答案 -->
              <template v-else>
                <div class="answer-box">
                  <div class="bg-w">
                    <div :ref="`answer${i}`" :class="{'answer':true,'is-open':item.isOpen}">{{ item.answer }}</div>
                    <span v-if="item.isMore && !item.isOpen" class="open" @click="open(item)">
                    阅读全文 <i class="el-icon-arrow-down"></i>
                  </span>
                  </div>

                </div>
                <el-collapse v-model="activeNames" @change="handleChange" v-if="item.source">
                  <el-collapse-item title="权威来源" :name="i">
                    <ul class="source-list">
                      <li>{{ `${item.source} ${item.webSite}` }}</li>
                    </ul>
                  </el-collapse-item>
                </el-collapse>
            </template>
            </template>
          </li>
        </ul>
      </el-scrollbar>


      <div class="ai-tag" v-if="resShow">内容由AI生成，仅供参考</div>

      <el-autocomplete
        class="ask-input"
        :popper-class="noData ? 'hide search-poper' : 'search-poper'"
        v-model="input"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入您要提问的问题"
        @select="search(input)"
        @keyup.enter.native="search(input)"
        @focus="noData = false"
      >
      <template slot-scope="{item}">
        <span :title="item.value">{{ item.value }}</span>
      </template>

        <el-button slot="append" @click="voice" style="padding: 1px;margin: 1px" id="voiceBtn"
          icon="el-icon-chat-line-round"
          >

            </el-button
        >
        <el-button slot="append" @click="search(input)"

          ><svg
              width="23"
              height="22"
              viewBox="0 0 23 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.66667 13.98L1.68376 12.2925C0.977272 11.8929 1.01617 10.8624 1.75079 10.5171L19.9822 1.94836C20.7635 1.58116 21.6117 2.30993 21.3663 3.13761L16.3377 20.101C16.1613 20.6959 15.4914 20.9882 14.9353 20.713L11.1111 18.82L9.80219 20.5786C9.2273 21.351 8 20.9444 8 19.9816V16.2095C8 15.9121 8.13237 15.6301 8.36118 15.4401L14.8889 10.02"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>

            </el-button
        >

      </el-autocomplete>

        <div class="question-tip" style="width: 960px;" v-if="!resShow">
          <p >您可以这样问:</p>
          <ul>
            <li @click="tipsClick('中国共产党党章建设的历程是怎样的？')"><span>#</span>中国共产党党章建设的历程是怎样的？</li>
            <li @click="tipsClick('如何理解中国共产党纪律处分条例中的“四种形态”？')"><span>#</span>如何理解中国共产党纪律处分条例中的“四种形态”？</li>
            <li @click="tipsClick('如何理解党政军民学，东西南北中，党是领导一切的？')"><span>#</span>如何理解党政军民学，东西南北中，党是领导一切的？</li>
            <li @click="tipsClick('如何加强党支部的组织生活建设?')"><span>#</span>如何加强党支部的组织生活建设?</li>
          </ul>
        </div>
      </div>
      <div class="main-r">
        <div class="tips">
          <div class="tips-title"><i>问题指引</i></div>
          欢迎使用智慧党建问答！<br />
          <div class="hs">
            请点击问题分类，
          可获得相应答案
          </div>

        </div>
        <ul class="type-list">
          <li  key="党建智能AI助手" @click="search('党建智能AI助手', true)" class="djAI">
            党建智能AI助手
          </li>
          <li  key="想看原著" @click="search('想看原著', true)" class="yz" style="">
            想看原著
          </li>
          <li  key="想看党建期刊" @click="search('想看党建期刊', true)" class="qkp">
            想看党建期刊
          </li>
        </ul>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import markMap from "@/views/APP/markMap.vue";
import { mapMutations, mapState } from 'vuex';
import { autocompleteMixin } from '../../mixins/mixin';
export default {
  components: {
    markMap // 声明 MarkMap 组件
  },
  mixins:[autocompleteMixin],
  data() {
    return {
      tabPosition: "right",
      activeName: "0",
      typeList: [
        "党建智能AI助手",
        "想看原著",
        "想看党建期刊",
      ],
      list: [],
      activeNames: [1],
      hightMounted: false,
      input:'',
      answer:'',
      openList:[],
      getApi:'',
      listApi:'',
      isQKList: false,
      isYZList: false,
      isOldQKList: false,
      isOldYZList: false,
      isAI: false,
      resShow: false,
      textOpen: true,
      markdownContent: `# 研究新质生产力对高质量发展影响的文献有哪些？

## 文献1:《新质生产力中国经济高质量发展的澎湃动能》
### 主题:
- 探讨新质生产力如何成为中国经济实现高质量发展的重要动力。

### 核心概念:
- 新质生产力:指推动经济高质量发展的关键力量。
- 高质量发展:经济增长的质量和效益比数量更重要的发展。

### 论点:
- 新质生产力对中国经济的高质量发展起到关键作用。
- 通过新质生产力的培育和提升，可以促进产业升级和结构优化。

## 文献2:《新质生产力赋能煤炭企业高质量发展研究》
### 主题:
- 研究新质生产力如何赋能煤炭企业实现高质量发展。

### 核心概念:
- 煤炭企业的高质量发展:提升企业的核心竞争力和市场竞争力。
- 新质生产力的赋能作用:通过创新要素的引入和应用，提升传统产业的生产效率和产品质量。

### 论点:
- 新质生产力的引入对煤炭企业的转型升级具有重要意义。
- 新质生产力的应用可以帮助煤炭企业优化生产流程、提升产品质量、降低能耗。

## 文献3:《新质生产力驱动下的高质量发展路径探析》
### 主题:
- 分析新质生产力在推动高质量发展中的作用路径。

### 核心概念:
- 新质生产力的驱动作用:作为发展的动力源，推动经济结构的优化升级。
- 高质量发展路径:经济发展的质量和效益提升的具体途径。

### 论点:
- 新质生产力是实现高质量发展的关键驱动力。
- 通过新质生产力的驱动，可以探索出适应中国国情的高质量发展路径。

## 文献4:《中国省级财政自给率对新质生产力的影响研究》
### 主题:
- 研究中国省级财政自给率与新质生产力之间的关系。

### 核心概念:
- 财政自给率:反映地方政府财政收入自给能力的指标。
- 新质生产力:推动区域经济高质量发展的新动力。

### 论点:
- 省级财政自给率对新质生产力的提升具有重要影响。
- 提高财政自给率可以为新质生产力的培育和发挥创造有利条件。

## 文献5:《发展新质生产力做好创新》
### 主题:
- 强调发展新质生产力并推动创新的重要性。

### 核心概念:
- 新质生产力的发展:经济发展新动力的形成和释放。
- 创新:驱动新质生产力形成和发展的关键因素。

### 论点:
- 发展新质生产力需要持续的创新支持。
- 通过创新活动，可以增强新质生产力，从而推动经济社会的高质量发展。`,
    };
  },
  mounted() {

    window.callToAndroidMethod = function () {
      Android.toAndroidMethod("123");
    }
    window.toH5Method = function (param) {
      alert(1);
    }

  },
  computed:{
    ...mapState(['question','uid','questionList'])
  },
  methods: {
    ...mapMutations(['setState']),
    open(item){
      item.isOpen = true
      this.$forceUpdate() 
    },
    openText(obj){
      obj.target.previousElementSibling.classList.remove('close-text');
      obj.target.nextElementSibling.style.display = "inline-block"
      obj.target.style.display = "none"
    },
    closeText(obj){
      obj.target.previousElementSibling.previousElementSibling.classList.add('close-text');
      obj.target.previousElementSibling.style.display = "inline-block"
      obj.target.style.display = "none"
    },
    getHeight(i) {
      this.$nextTick(() => {
        this.$refs[`answer${i}`][0].offsetHeight > 200
        this.$forceUpdate() 
      });
    },
    voice(){
        window.callToAndroidMethod()
    },
    search(question, isRightType) {
      if(typeof question === 'string' && question.trim() == ''){
        this.$message.warning('请输入问题！')
        return
      }
      this.resShow = true
       this.isAI =  true
      this.setState({key:'questionList',value:''})
      let isString = typeof(question)=='string'
      if ((isString && !question) || (isString && question && !question.split(' ').join('')) || (!isString && question && !question.uid && !isRightType)) return this.$message.warning('请输入检索词！')
      if(isRightType){
        this.setState({key:'question',value: ''})
        this.setState({key:'uid',value: ''})
        if(question==='想看原著') {
          this.answer='请输入著作名称、主编或作者姓名。'
          this.isQKList = false
          this.isYZList = true
          this.isAI = false
        } else if(question==='想看党建期刊') {
          this.answer='请输入党建期刊名称、主编或作者姓名。'
          this.isQKList = true
          this.isYZList = false
          this.isAI = false
        }else if(question==='党建智能AI助手') {
          this.answer='请输入您要提问的问题。'
          this.isQKList = false
          this.isYZList = false
          this.isAI =  true
        } else {
          this.isQKList = false
          this.isYZList = false
          this.isAI = false
          if(question=='党史相关问题') this.answer='您可以输入党史相关问题，例如“中国共产党成立于1921年7月23日，为什么7月1日是党的诞生纪念日？”、“什么是伟大建党精神？”等，'
          else if(question=='党章相关问题') this.answer='您可以输入党章相关问题，例如“中国共产党党章建设的历程是怎样的？”；也可以输入具体章节，例如“第一章 党员”；'
          else if(question=='习近平新时代中国特色社会主义思想相关问题') this.answer='您可以输入习近平新时代中国特色社会主义思想相关问题，例如“如何理解习近平新时代中国特色社会主义思想是系统科学的理论体系？”、“如何理解党政军民学，东西南北中，党是领导一切的？”等；'
        }
        let obj = {answer:this.answer}
        this.list.push(
          question,
          obj
        )
        this.scrollNewstQuestion()
        this.noData = true
        this.resShow = true
      }
      else {
        // 存在uid时，清空推荐问题列表；不存在时，请求接口改变推荐问题列表
        if(question.uid) {
          this.setState({key:'question',value: question.value || question.name || question.buildTitle})
          this.setState({key:'uid',value: question.uid})
          this.setState({key:'questionList',value:''})
          this.getAnswer()
          this.resShow = true
          this.input = ''
        } else {
          this.setState({key:'question',value: typeof(question)=='string' ? question : this.input})
          this.setState({key:'uid',value: ''})
          this.getQuestionList()

          // this.input = ''
        }
      }
      this.answer = "";
    },
       tipsClick(str){
      this.input = str
      this.resShow = true
      this.search(this.input)
    },
    // 展示最新的问题
    scrollNewstQuestion(){
      this.$nextTick(() => {
        this.$forceUpdate()
        document.getElementById(`item${this.list.length - 2}`).scrollIntoView()
      })
    },
    // 根据关键词推送问题列表
    getQuestionList(){
      if(this.isQKList){
        this.listApi = 'data/custom/getJournallist'
      } else if(this.isYZList) {
        this.listApi = 'data/custom/GetWorklist'
      } else if(this.isAI ) {
        this.listApi = 'vector/getRelaVector'
      } else {
        this.listApi = "data/custom/GetQandAlist"
      }
      if(this.listApi == 'vector/getRelaVector'){
        var myHeaders = new Headers();
        myHeaders.append("User-Agent", "Apifox/1.0.0 (https://www.apifox.cn)");
        myHeaders.append("Accept", "*/*");
        myHeaders.append("Host", "10.31.91.11:8101");
        myHeaders.append("Connection", "keep-alive");

        var requestOptions = {
           method: 'GET',
           headers: myHeaders,
           redirect: 'follow'
        };
        var that = this;
        fetch(process.env.VUE_APP_AIAPI_URL+"vector/getRelaVector?question="+this.input+"&size=5", requestOptions)
           .then(response => response.text())
           .then(result => {
             const obj = JSON.parse(result)
             if(obj.code == 500){
               this.list.push(this.question,{answer:obj.msg})
               that.input = ''
             }else {
               obj.data[0].content = obj.data[0].content.replace(/\r\n/g,'<br/>')
               fetch(process.env.VUE_APP_AIAPI_URL+"vector/getMind?question="+this.input+"&size=5", requestOptions)
                   .then(response => response.text())
                   .then(re => {
                     const mk = JSON.parse(re)
                     obj.mk = mk.data.markDown
                     that.list.push(that.input,{result:obj,isAI:true})
                     setTimeout(function (){
                       that.scrollNewstQuestion()
                       that.input = ''
                     },500)
                   }).catch(error => console.log('error', error));




             }



           })
           .catch(error => console.log('error', error));



        return
      }

      this.axios
        .post(this.listApi, {question: this.input})
        .then((res) => {
          if (res.status == 200) {
            let data = res.data.rows
            let activeItem
            if(data.length>0){
              data.some(item => {
                if(item.name===this.input || item.buildTitle === this.input) {
                  activeItem = item
                  return this.search(item)
                }
              })
            }
            if(activeItem) return
            this.setState({key:'questionList',value: data})
            if(!data.length) {
              console.log('this.isQKList',this.isQKList)
              console.log('this.isYZList',this.isYZList)
              let aaa = ''
              if(this.isQKList) aaa = '没找到您要的期刊，您可以询问其他问题。'
              else if(this.isYZList) aaa = '没找到您要的原著，您可以询问其他问题。'
              else aaa = '抱歉，没有搜索到相关结果，请尝试其他关键词。'
              console.log('aaa',aaa)
              this.list.push(this.question,{answer:aaa})
              this.isQKList = false
              this.isYZList = false
            } else this.list.push(this.question,{answer:data.filter((item,i) => i<10),isQuestionList:true,isMore:data.length>10,isQKList:this.isQKList,isYZList:this.isYZList}) // 推荐前10条，多出的显示更多
            this.scrollNewstQuestion()
            return this.noData = true // 关闭问题提示列表框
          } else {
            this.$message.error("获取失败！");
          }
        });
    },
    // 点击推荐的问题列表下的更多展示所有推荐问题
    showMore(index){
      this.list = this.list.map((item,i) => {
        if(index===i) return {answer:this.questionList, isQuestionList:true, isMore:false}
        else return item
      })
    },
    // 点击推荐的问题列表
    questionListClick(item){
      if(item.buildTitle) { // 原著
        this.isOldYZList = true
        this.isOldQKList = false
      }else if(item.name){ // 期刊
        this.isOldYZList = false
        this.isOldQKList = true
      }else if(item.question) {
        this.isOldYZList = false
        this.isOldQKList = false
      }// 问题
      this.setState({key:'question',value:item.buildTitle || item.name || item.question})
      this.setState({key:'uid',value:item.uid})
      this.getAnswer(true)
    },
    getAnswer(isQList) {
      if(isQList){
        if(this.isOldQKList) this.getApi = `data/custom/getJournalData?uid=${this.uid}`
        else if(this.isOldYZList) this.getApi = `data/custom/GetWorkData?uid=${this.uid}`
        else this.getApi = `data/custom/GetQandAData?uid=${this.uid}`
      } else {
        if(this.isQKList) this.getApi = `data/custom/getJournalData?uid=${this.uid}`
        else if(this.isYZList) this.getApi = `data/custom/GetWorkData?uid=${this.uid}`
        else this.getApi = `data/custom/GetQandAData?uid=${this.uid}`
      }
      // 根据uid找答案
      this.axios.get(this.getApi).then((res) => {
        if (res.status == 200) {
          let isQKOrYZ = this.isOldQKList || this.isOldYZList || this.isQKList || this.isYZList
          let answer = isQKOrYZ ? (res.data && res.data.data) : (res.data && res.data.data && res.data.data.answer)
          this.answer = answer || "抱歉，没有搜索到相关结果，请尝试其他关键词。"
          if(isQKOrYZ) {
            this.list.push(this.question,{answer:this.answer,isQKOrYZ})
            console.log(this.list);
            return this.scrollNewstQuestion()
          }
          this.list.push(
            this.question,
          {answer:this.answer,source:res.data.data.source,webSite:res.data.data.webSite}
          )
          this.$nextTick(() => {
            let index = this.list.length - 1
            this.list[index].isMore = this.$refs[`answer${index}`][0].scrollHeight > 200
            this.activeNames.push(this.list.length-1)
            this.isOldQKList = false
            this.isOldYZList = false
            return this.scrollNewstQuestion()
          })
          this.noData = true
        } else {
          this.$message.error("获取失败！");
        }
      });
    },
    calcEllipsis(str){
      if(str.length<500) return str
      return str.substr(0, 500) + "..."
    },
    handleClick() {},
    handleChange(val) {
      console.log(val);
    },
  },
  watch:{
    input(){
      this.noData = false
    }
  },
};
</script>
<style lang="scss" scoped>
.header{
    min-width: 1200px;
    height: 1200px;
    background: url(../../assets/images/党建AI首页.png) no-repeat antiquewhite center top;
    background-size: cover;
}
.main {
  overflow: hidden;
  font-size: 16px;
  margin-bottom: 30px;
.pop-span{
  max-width: 100%!important;
}
  .main-l {
.question-tip{
  border-radius: 16px;
  padding: 20px 24px;
  background: #FFF;
  box-shadow: 0px 0px 16px 0px rgba(195, 173, 141, 0.15);
  margin-top: 20px;
  text-align: left;
  p{
    color: #1F1F1F;
    font-family: "PingFang SC";
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  li{
    cursor: pointer;
    padding: 11px 12px;
    margin: 10px 0;
    border-radius: 6px;
    background: #FFFBF5;
    span{
      color: #EB4447;
      margin-right: 5px;
    }
  }
}
    float: left;
    width: 960px;
    position: relative;

    .question-list{
      line-height: 1.6;
      li{
        &:hover{
          cursor: pointer;
          color: #de1c26;
        }
      }
      .is-more{
        color: #de1c26;
        &:hover{
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
    .qa-list {
      min-height: 600px;
      padding-bottom: 10px;
      background-color: transparent;
      //border-radius: 10px;
      //
      //border: 1px solid #fae0e0;
      & > li {
        margin-top: 10px;
        &:nth-child(2n + 1) {
          text-align: right;
          .question {
            //background: linear-gradient(270deg, #ffebeb 0%, #fff9f9 11.44%);
            color: #2C2C2B;
            padding: 15px 0;
            display: inline-block;
            min-height: 50px;
            line-height: 1.6;
            padding: 12px 10px 4px 12px;
            max-width: 800px;
            position: relative;
            text-align-last: left;
            background-color: #FAEFE1;
            border-radius: 10px;
            margin-right: 25px;
           /* &::before {
              content: "问：";
              position: absolute;
              left: 10px;
              top: 8px;
              font-weight: bold;
              padding: 4px 9px;
              font-style: italic;
              background: linear-gradient(90deg, #fc1515 0%, #ff6109 101%);
              color: #fff;
            }*/
          }
        }
        &:nth-child(2n) {
          //background: linear-gradient(90deg, #ffebeb 0%, #fff9f9 15.2%);
          margin-right: 30px;
          padding: 10px 30px 10px 0px;
          position: relative;
          &::before {
            /*content: "答：";
            position: absolute;
            left: 10px;
            font-weight: bold;
            padding: 6px 9px 7px;
            font-style: italic;
            background: linear-gradient(90deg, #fc1515 0%, #ff6109 101%);
            color: #fff;*/
          }
          .answer-box {
            background-image: url("../../assets/images/Fram51.png");
            background-repeat: no-repeat;
            padding-top: 60px;

            .bg-w{
              padding: 20px;
              border-radius: 5px;
              background-color: white;

            }
            margin-bottom: 10px;
            .answer {
              text-align: left;
              max-height: 286px;
              overflow: hidden;
              white-space: pre-wrap;
              line-height: 1.6;


              &.is-open{
                max-height: none;
              }
               ::v-deepp {
                text-indent: 2em;
              }
            }
            .open {
              display: block;
              text-align: center;
              color: #de1c26;
              height: 50px;
              line-height: 50px;
              cursor: pointer;
            }
          }
        }
      }
      .qk-answer{
        .bg-w{
          background-color: white;
          border-radius: 5px;
          padding: 20px;
          .close-text{
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
        background-image: url("../../assets/images/Fram51.png");
        background-repeat: no-repeat;
        padding-top: 60px;
        img{
          width: 110px;
          height: 160px;
          vertical-align: middle;
        }
        span{
         /* margin-left: 20px;
          display: inline-block;
          vertical-align: middle;
          max-width: 330px;*/
        }
      }
    }
  }
  .main-r {
    border-radius: 15px;
    background-color: white;
    float: left;
    width: 270px;
    border: 1px solid #E7E4E1;
    padding: 15px;
    margin-left: 20px;
    margin-top: 40px;
    .tips {
      color: #de1c26;
      font-size: 14px;
      line-height: 1.6;
      font-size: 15px;
          color: #1F1F1F;
       .hs{
          color: #9B9B9B;
         font-size: 12px;
         margin-top: 10px;
         margin-bottom: 10px;
        }
      .tips-title {
        display: block;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        letter-spacing: 3px;

        i {
          background-image: url("../../assets/images/deng.png");
          padding-left: 18px;
          background-repeat: no-repeat;
          font-size: 15px;
          color: black;
        }
      }
      text-align: left;
    }
    .type-list {
      .djAI{
        background-image: url(../../assets/images/djai.png);
        background-size: 100% 100%;
      }
      .yz{
        background-image: url(../../assets/images/yz.png);
        background-size: 100% 100%;
      }
      .qkp{
        background-image: url(../../assets/images/qkp.png);
        background-size: 100% 100%;
      }
      li {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: flex-start;
            background: linear-gradient(270.04deg, #de1c26 0.04%, #ff5925 100.79%);
            height: 82px;
            margin-top: 10px;
            width: 236px;
            text-align: left;
            color: #fff;
            padding: 0 5px;
            cursor: pointer;
            -webkit-box-align: start;
        padding-left: 30px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
}
::v-deep {
  .el-collapse,
  .el-collapse-item__wrap,
  .el-collapse-item__header {
    border: none;
  }
  .el-collapse-item {
    border-top: 1px dotted #b1aeae;
    .el-icon-arrow-right:before {
      font-family: "iconfont" !important;
      content: "\e71a";
    }
  }
  .el-collapse-item__header,
  .el-collapse-item__wrap {
    background-color: transparent;
  }
  .el-collapse-item__header {
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    color: #de1c26;
  }
  .el-collapse-item__content {
    font-size: 16px;
    line-height: 1.6;
    padding-bottom: 15px;
  }
  .el-collapse-item__arrow.is-active {
    transform: rotate(180deg);
  }
  .ask-input{
    margin-top: 40px;
    width: 100%;
  }
  .el-input-group__append {
    border: none;
    padding-left: 27px;
    padding-right: 27px;

  }
  .el-input {
    font-size: 16px;
  }
  .el-input__inner {

    height: 120px;
    line-height: 1px;
    border-right: none;
    border-color: #DE1C26;
    border-radius: 0;
    border-radius: 10px 0 0 10px;
    background-image: url("../../assets/images/Group14.png");
    background-repeat: no-repeat;
    background-position:10px 70px ;
    padding-bottom: 60px;
  }
  .el-input-group__append {
    .el-button--default{
      background-color: #F2A4A8;
      border-radius: 30px;
      width: 40px;
      height: 40px;
      margin-bottom: 10px;
    }
    background-color: #FFFFFF;
    border: 1px solid #DE1C26;
    border-left: 0;
     vertical-align: bottom;

    color: #fff;
      border-radius: 0 10px 10px 0;
    svg {
      margin-top: -5px;
      margin-left: -12px;
      vertical-align: bottom;
    }
  }
}

.ai-tag{
  margin-top: 20px;color: rgb(136, 136, 136);font-size: 14px;
}
</style>
